import { useEffect } from "react";
import styled from "styled-components";
import { TextField } from "@mui/material";
import { Text } from "../Text";
import { useTranslation } from "react-i18next";

const InputContainer = styled.div`
  width: 100%;
`;

const StyledInput = styled(TextField)`
  && {
    .MuiOutlinedInput-root {
      border-radius: 14px;
      height: 51px;
      background: transparent;
      border: 0;
    }

    .MuiOutlinedInput-notchedOutline {
      border: 0;
    }

    .MuiFormHelperText-root.Mui-error {
      text-align: ${(p) => (p.isRtl ? "right" : "left")};
    }

    .MuiInputBase-input {
      text-align: center;
      font-size: ${(p) => (p.fontSize ? p.fontSize : "inherit")};
    }

    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* input[type="checkbox"] :: {
      background: rgb(0, 85. 164)
    } */
  }
`;

const StyledDiv = styled.div(({ error, theme, height }) => ({
  borderRadius: 10,
  backgroundColor: theme.color.white,

  height: height ? height : "3em",
  border:
    !!error === true
      ? `1px solid ${theme.color.error}`
      : `1px solid ${theme.color.blue}`,
  fontSize: 16,
  display: "flex",
  paddingInlineEnd: "1em",
  paddingInlineStart: "1em",
  lineHeight: 1,
}));

const StyleEndImg = styled.img(({ ...props }) => ({
  marginInlineStart: "auto",
  width: 20,
  height: 20,
  alignSelf: "center",
}));

const StyleStartImg = styled.img(({ ...props }) => ({
  width: 22,
  height: 22,
  marginInlineEnd: "1em",
  alignSelf: "center",
}));

const inputLabelProps = {
  shrink: true,
  margin: "2rem",
};

const Label = styled(Text)``;

const InputMUI = ({
  label,
  placeholder,
  width = "full",
  isRtl,
  fontSize,
  validation,
  errorText,
  value,
  startImg,
  endImg,
  showPassword,
  helperText,
  ...props
}) => {
  useEffect(() => {}, [value]);

  const { t } = useTranslation();

  return (
    <InputContainer width={width}>
      {label && <Label>{label}</Label>}
      <StyledDiv error={!!helperText}>
        {!!startImg && <StyleStartImg src={startImg} alt="input-start-img" />}
        <StyledInput
          InputLabelProps={inputLabelProps}
          placeholder={placeholder || label}
          fullWidth={width === "full"}
          size="small"
          fontSize={fontSize}
          error={!!errorText}
          {...props}
          dir={isRtl === true ? "rtl" : "ltr"}
          isRtl={isRtl}
        />
        {!!endImg && (
          <StyleEndImg
            src={endImg}
            alt="input-end-img"
            onClick={() => showPassword(props.type === "password")}
          />
        )}
      </StyledDiv>
      <Text.Error style={{ textAlign: "start" }}>{t(helperText)}</Text.Error>
    </InputContainer>
  );
};

export default InputMUI;
